import EditPatientAlert from './EditPatientAlert'

export default EditPatientAlert
